var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail',{attrs:{"base-info":_vm.baseInfo,"data":_vm.data,"statusModule":"rdsBackup","extra-info":_vm.extraInfo,"onManager":_vm.onManager}})
}
var staticRenderFns = []

export { render, staticRenderFns }